import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import QuickNavigationPaneImpl from './quick-navigation-pane.jsx';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Quick navigation pane component.
 * Typically, used to display quick navigation components(QuickEventsNavigation, QuickLeaguesNavigation and QuickMeetingsNavigation) with different rendering options.
 *
 * @class QuickNavigationPane
 * @memberof Mojito.Presentation.Components
 */

/**
 * QuickNavigationPane prop types.
 *
 * @property {boolean} [isEnabled] - Flag to determinate the visibility state of the component.
 * @property {Function} [onOutsideClick = ()=>{}] - Callback triggered when the user clicks outside the open popup.
 * @property {node} [children] - Child components.
 *
 * @memberof Mojito.Presentation.Components.QuickNavigationPane
 */
const propTypes = {
    isEnabled: PropTypes.bool,
    onOutsideClick: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

const defaultProps = {
    onOutsideClick: noop,
};

export default UIView('QuickNavigationPane', QuickNavigationPaneImpl, propTypes, defaultProps);
